// NOTE: We're currently working on a new navigation (bbc_nav_v4)
// This component is only used by the nav v3. The nav v4 equivilent of
// this is in top-nav-app-logo.tsx. If you make a modification in this component
// make sure to also update the other component or your changes won't exist in
// the new nav.
import { MouseEvent } from 'react';

// eslint-disable-next-line frontbucket-patterns/no-new-emotion-styled
import styled from '@emotion/styled';
import { useIntl } from 'react-intl-next';

import { ProductHome, AppHome } from '@atlaskit/atlassian-navigation';
import { BitbucketIcon, BitbucketLogo } from '@atlaskit/logo';
import { token } from '@atlaskit/tokens';
import { BitbucketPrideIcon } from '@atlassian/bitkit-icon';

import BitbucketPrideLogo from '../bitbucket-pride-logo';

import { HorizontalNavProps } from './horizontal-nav-context';
import messages from './horizontal-nav.i18n';

const SizedBitbucketIcon = () => (
  <BitbucketIcon shouldUseNewLogoDesign size="small" />
);

const AppHomeContainer = styled.div({
  color: token('color.text'),
  'a:hover': {
    textDecoration: 'none',
  },
});

type ProductHomeWithPrideProps = {
  hasPride: boolean;
  handleProductClick: HorizontalNavProps['handleProductClick'];
};

export const ProductHomeWithPride = ({
  hasPride,
  handleProductClick,
}: ProductHomeWithPrideProps) => {
  const intl = useIntl();

  const sharedProductAppHomeProps = {
    href: '/',
    testId: 'product-home',
    'aria-label': intl.formatMessage(messages.bitbucketHomeAriaLabel),
    onClick: (e: MouseEvent<HTMLElement>) => handleProductClick(e),
  };

  if (hasPride) {
    return (
      <ProductHome
        icon={BitbucketPrideIcon as typeof BitbucketIcon}
        logo={BitbucketPrideLogo as typeof BitbucketLogo}
        {...sharedProductAppHomeProps}
      />
    );
  } else {
    return (
      <AppHomeContainer>
        <AppHome
          icon={SizedBitbucketIcon}
          name="Bitbucket"
          {...sharedProductAppHomeProps}
        />
      </AppHomeContainer>
    );
  }
};
